<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select filterable v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客信息：">
					<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in customerList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单编号：">
					<el-input v-model="formInline.code" placeholder="请输入订单编号" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="会员编号：">
					<el-input v-model="formInline.vipNo" placeholder="请输入会员编号" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="订单状态：">
					<el-select v-model="formInline.state" placeholder="请选择订单状态" size="small" @change="inputChange">
						<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单来源：">
					<el-select v-model="formInline.orderSource" placeholder="请选择订单来源" size="small" @change="inputChange">
						<el-option v-for="item in orderSourceList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否确认：">
					<el-select v-model="formInline.isConfirm" placeholder="请选择是否确认" size="small" @change="inputChange">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="已确认" :value="true"></el-option>
						<el-option label="未确认" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="下单日期：">
					<el-date-picker
						v-model="dateStr"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						size="small"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/salesOrder/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/salesOrder/index', 'export')" size="small" type="warning" class="el-icon-download" @click="exportSalesOrder" :loading="exportLoading">导出</el-button>
				</el-form-item>
			</el-form>
			<div class="table-minheight">
				<STable :columns="columnsData" :data="listData" :loading="loading" border stripe :row-class-name="tableRowClassName" @get-data="getListData">
					<template #code>
						<el-table-column label="订单号" width="220" align="center">
							<template #default="scope">
								<el-link type="primary" :underline="false" @click="handleDetail(scope.row)">
									{{ scope.row.code }}
								</el-link>
							</template>
						</el-table-column>
					</template>
					<template #stateStr>
						<el-table-column label="状态" width="90" align="center">
							<template #default="scope">
								<el-tag v-if="scope.row.state === 1" type="warning">{{ scope.row.stateStr }}</el-tag>
								<el-tag v-else-if="scope.row.state === 2" type="danger">{{ scope.row.stateStr }}</el-tag>
								<el-tag v-else-if="scope.row.state === 4" type="info">{{ scope.row.stateStr }}</el-tag>
								<el-tag v-else type="success">{{ scope.row.stateStr }}</el-tag>
							</template>
						</el-table-column>
					</template>
					<template #isConfirm>
						<el-table-column label="是否确认" width="120" align="center">
							<template #default="scope">
								<el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
								<el-tag v-else type="danger">未确认</el-tag>
							</template>
						</el-table-column>
					</template>
					<template #arrearsMoney>
						<el-table-column label="欠款金额" min-width="110" align="center">
							<template #default="scope">
								<span style="color: #f56c6c; font-weight: 600; white-space: nowrap" v-money="(scope.row.totalMoney - scope.row.totalPayMoney)">￥{{ (scope.row.totalMoney - scope.row.totalPayMoney).toFixed(2) }} 元</span>
							</template>
						</el-table-column>
					</template>
					<template #isPhoneBonus>
						<el-table-column label="是否电话提成" width="100" align="center">
							<template #default="scope">
								<el-tag v-if="scope.row.isPhoneBonus" type="success">有</el-tag>
								<el-tag v-else type="danger">没有</el-tag>
							</template>
						</el-table-column>
					</template>
					<template #isGrantBonus>
						<el-table-column label="是否提成" width="100" align="center">
							<template #default="scope">
								<el-tag v-if="scope.row.isGrantBonus" type="success">已创建</el-tag>
								<el-tag v-else type="danger">未创建</el-tag>
							</template>
						</el-table-column>
					</template>

					<template #operation>
						<el-table-column label="操作" width="200" align="center" fixed="right">
							<template #default="scope">
								<el-button v-if="btnPermission.delete && !scope.row.isConfirm" size="mini" class="el-icon-delete" type="danger" @click="handleDelete(scope.row)">删除</el-button>
								<el-button v-if="btnPermission.confirm && !scope.row.isConfirm" size="mini" class="el-icon-finished" type="warning" @click="handleConfirm(scope.row)">确认</el-button>
								<el-button
									v-if="btnPermission.repairArrears && scope.row.isConfirm && scope.row.state === 2"
									size="mini"
									class="el-icon-finished"
									type="warning"
									@click="handleRepairArrears(scope.row)"
								>
									补欠款
								</el-button>
								<el-button
									v-if="btnPermission.createCommission && scope.row.isConfirm && !scope.row.isGrantBonus && scope.row.state !== 4 && scope.row.state !== 2"
									size="mini"
									class="el-icon-cherry"
									type="success"
									@click="handleCreateCommission(scope.row)"
								>
									创建提成
								</el-button>
								<el-button v-if="btnPermission.cancel && scope.row.isConfirm && scope.row.state === 3" size="mini" class="el-icon-delete" type="danger" @click="handleCancel(scope.row)">
									退单
								</el-button>
							</template>
						</el-table-column>
					</template>
				</STable>
				<!-- 分页组件 -->
				<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
			</div>
		</topTab>
		<!-- 补欠款 -->
		<el-dialog :visible.sync="dialogVisible" title="订单补款" width="1050px" append-to-body :close-on-click-modal="false" custom-class="arrears-dialog">
			<div class="arrears-dialog-content">
				<el-form label-width="80px" size="small" class="arrears-form">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="订单编号">
								<span>{{ currentArrearsOrder ? currentArrearsOrder.code : "" }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="订单金额">
								<span style="color: #f56c6c; font-weight: 600" v-money="currentArrearsOrder ? currentArrearsOrder.totalMoney : 0">￥{{ currentArrearsOrder ? currentArrearsOrder.totalMoney : 0 }}元</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="已付金额">
								<span style="color: #67c23a; font-weight: 600">￥{{ currentArrearsOrder ? currentArrearsOrder.totalPayMoney : 0 }}元</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="欠款金额">
								<span style="color: #e6a23c; font-weight: 600">￥{{ currentArrearsOrder ? (currentArrearsOrder.totalMoney - currentArrearsOrder.totalPayMoney).toFixed(2) : 0 }}元</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="支付方式" required>
						<div class="pay-types-row">
							<div v-for="(payTypeItem, index) in payTypes" :key="payTypeItem.payTypeId" class="pay-type-item" :class="{ 'pay-type-item-active': payTypeItem.payMoney > 0 }">
								<span class="pay-type-label">{{ payTypeItem.payTypeName }}</span>
								<el-input-number v-model.number="payTypeItem.payMoney" placeholder="0.00" :min="0" :step="0.01" :precision="2" size="small" controls-position="right"></el-input-number>
								<el-input v-model="payTypeItem.payComment" placeholder="备注" clearable size="small"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="支付记录">
						<el-table :cell-class-name="$moneyCellClass" :data="payHistoryList" size="small" border>
							<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
							<el-table-column prop="typeStr" label="付款类型" align="center" width="80"></el-table-column>
							<el-table-column prop="payTypeStr" label="支付方式" align="center" width="100"></el-table-column>
							<el-table-column label="支付金额" align="center" width="100">
								<template #default="scope">￥{{ scope.row.payMoney }}元</template>
							</el-table-column>
							<el-table-column prop="creator" label="收款人" align="center" width="100"></el-table-column>
							<el-table-column label="支付时间" align="center" width="170">
								<template #default="scope">
									{{ scope.row.createTime ? formatDate(scope.row.createTime) : "" }}
								</template>
							</el-table-column>
							<el-table-column prop="payComment" label="备注" align="center" width="auto"></el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<span>
					<el-button size="small" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" size="small" :loading="isSubmitting" @click="handleSubmitPayArrears">确认补款</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 创建提成 -->
		<createCommission ref="createCommission"></createCommission>
		<!-- 销售订单详情 -->
		<detailDialog ref="detailDialog"></detailDialog>
		<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetSalesOrderPageList, DeleteSalesOrder, ConfirmSalesOrder, PaySalesOrderArrearsMoney, ExportSalesOrder, CancelSalesOrder } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetPayHistoryList } from "@/api/payApi.js";
import detailDialog from "@/views/product/sales/detailDialog.vue";
import createCommission from "@/views/product/sales/createCommission.vue";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";

export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "销售订单"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			exportLoading: false, // 导出按钮 loading
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				isConfirm: null,
				code: "",
				vipNo: "",
				state: 0,
				orderSource: 0,
				customerKeyId: "",
				startTime: null,
				endTime: null
			},
			storeList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "下单时间",
					width: "170",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "100",
					align: "center",
				},
				{
					prop: "customer.name",
					label: "顾客姓名",
					minWidth: "90",
					align: "center",
				},
				{
					prop: "orderSourceStr",
					label: "订单来源",
					minWidth: "150",
					align: "center",
				},
				{
					prop: "totalProductMoney",
					label: "订单金额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "totalMoney",
					label: "收费金额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "content",
					label: "订单商品内容",
					width: "320",
					align: "center"
				},
				{
					slot: "code",
					label: "订单号",
					minWidth: "180",
					isKeep: true,
					align: "center"
				},
				{
					prop: "customer.phone",
					label: "顾客手机号",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "经办人",
					width: "100",
					align: "center"
				},
				{
					slot: "stateStr",
					label: "状态",
					minWidth: "80",
					align: "center"
				},
				{
					prop: "vipInfo.vipNo",
					label: "会员号",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "vipInfo.balance",
					label: "会员余额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "totalPayMoney",
					label: "总支付金额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "arrearsMoney",
					label: "欠款金额",
					minWidth: "120",
					align: "center"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					align: "center"
				},
				{
					prop: "confirmDate",
					label: "确认时间",
					align: "center",
					width: "170"
				},
				{
					slot: "isPhoneBonus",
					label: "电话提成",
					align: "center",
					width: "100"
				},
				{
					prop: "phoneBonusUserName",
					label: "电话提成人",
					align: "center",
					width: "120"
				},
				{
					slot: "isGrantBonus",
					label: "是否提成",
					align: "center",
					width: "100"
				},
				{
					prop: "grantBonusUserName",
					label: "创建提成人",
					align: "center",
					width: "120"
				},
				{
					prop: "grantTime",
					label: "创建提成时间",
					align: "center",
					width: "170"
				},
				{
					slot: "operation",
					label: "操作",
					minWidth: "120",
					align: "center",
					fixed: "right"
				}
			],
			btnPermission: {
				confirm: false,
				delete: false,
				repairArrears: false,
				createCommission: false,
				cancel: false,
				export: false
			},
			stateList: [],
			orderSourceList: [],
			payTypeList: [],
			currentArrearsOrder: null,
			payTypes: [],
			payHistoryList: [],
			dialogVisible: false,
			isSubmitting: false,
			dateStr: [],
			customerList: [],
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	// 注册组件
	components: {
		detailDialog,
		createCommission,
		exportBlockDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.getOrderStatusList();
		this.getOrderSourceList();
		this.getPayTypeList();
		// 检查按钮权限
		this.btnPermission.confirm = this.$checkBtnPermission("/salesOrder/index", "confirm");
		this.btnPermission.delete = this.$checkBtnPermission("/salesOrder/index", "delete");
		this.btnPermission.repairArrears = this.$checkBtnPermission("/salesOrder/index", "repairArrears");
		this.btnPermission.createCommission = this.$checkBtnPermission("/salesOrder/index", "createCommission");
		this.btnPermission.cancel = this.$checkBtnPermission("/salesOrder/index", "cancel");
		this.btnPermission.export = this.$checkBtnPermission("/salesOrder/index", "export");
	},
	computed: {
		arrearsPayTypeList() {
			var allowedTypes = [1, 2, 3, 4, 6];
			return this.payTypeList.filter((item) => allowedTypes.includes(item.payTypeId));
		}
	},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null
			};
			GetSalesOrderPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 点击删除按钮
		handleDelete(row) {
			this.$confirm("确认删除该订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					DeleteSalesOrder({
						keyId: row.keyId
					})
						.then((res) => {
							if (res.code == 1) {
								this.getListData();
								this.$message({
									type: "success",
									message: "订单删除成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("订单删除失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		},
		// 点击确认按钮
		handleConfirm(row) {
			this.$confirm("是否确认该订单？", "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					ConfirmSalesOrder({
						keyId: row.keyId
					})
						.then((res) => {
							if (res.code == 1) {
								this.getListData();
								this.$message({
									type: "success",
									message: "订单确认成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("订单确认失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch((err) => {
					this.$message({
						type: "info",
						message: "已取消确认"
					});
				});
		},
		//获取订单来源
		getOrderSourceList() {
			GetEnumConfigListByCode({
				code: "StoreOrderSource"
			})
				.then((res) => {
					if (res.code == 1) {
						this.orderSourceList = [];
						res.data.forEach((item) => {
							this.orderSourceList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.orderSourceList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		//获取销售订单状态
		getOrderStatusList() {
			GetEnumConfigListByCode({
				code: "SalesOrderState"
			})
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.stateList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 点击补欠款按钮
		handleRepairArrears(row) {
			this.payTypes = [];
			this.arrearsPayTypeList.forEach((item) => {
				this.payTypes.push({
					payTypeId: item.payTypeId,
					payTypeName: item.payTypeName,
					payMoney: 0,
					payComment: ""
				});
			});
			this.currentArrearsOrder = row;
			this.dialogVisible = true;
			this.getPayHistoryList(row.keyId);
		},
		// 获取支付记录列表
		getPayHistoryList(businessKeyId) {
			GetPayHistoryList({
				KeyId: businessKeyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.payHistoryList = res.data || [];
						this.payHistoryList.forEach((item) => {
							var payType = this.payTypeList.find((p) => p.payTypeId == item.payType);
							if (payType) {
								item.payTypeStr = payType.payTypeName;
							}
						});
					} else {
						this.payHistoryList = [];
					}
				})
				.catch((err) => {
					this.payHistoryList = [];
				});
		},
		// 日期格式化
		formatDate(date) {
			if (!date) return "";
			var d = new Date(date);
			var year = d.getFullYear();
			var month = String(d.getMonth() + 1).padStart(2, "0");
			var day = String(d.getDate()).padStart(2, "0");
			var hours = String(d.getHours()).padStart(2, "0");
			var minutes = String(d.getMinutes()).padStart(2, "0");
			var seconds = String(d.getSeconds()).padStart(2, "0");
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},
		// 处理支付金额输入，限制只能输入两位小数
		handlePayMoneyInput(event) {
			let value = event.target.value;
			// 清除非数字和非小数点字符
			value = value.replace(/[^\d.]/g, "");
			// 只保留第一个小数点
			value = value.replace(/\.{2,}/g, ".");
			// 如果有小数点，限制只能输入两位小数
			const parts = value.split(".");
			if (parts.length > 1 && parts[1].length > 2) {
				value = parts[0] + "." + parts[1].substring(0, 2);
			}
			// 更新支付金额
			this.payType.payMoney = value;
		},
		// 充值记录补款弹窗
		handleSubmitPayArrears() {
			var totalPayMoney = 0;
			for (var i = 0; i < this.payTypes.length; i++) {
				var payTypeItem = this.payTypes[i];
				if (payTypeItem.payMoney <= 0) continue;
				var payMoney = parseFloat(payTypeItem.payMoney);
				if (isNaN(payMoney)) {
					this.$message.error("请输入有效的数字金额");
					return;
				}
				if (payMoney <= 0) {
					this.$message.error("请输入有效的支付金额（必须大于0）");
					return;
				}
				payTypeItem.payMoney = parseFloat(payMoney.toFixed(2));
				totalPayMoney += payTypeItem.payMoney;
			}
			if (totalPayMoney <= 0) {
				this.$message.error("请输入有效的支付金额（必须大于0）");
				return;
			}
			this.$confirm("确认补款吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.isSubmitting = true;
					PaySalesOrderArrearsMoney({
						keyId: this.currentArrearsOrder.keyId,
						payTypes: this.payTypes
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "充值记录补款成功！"
								});
								this.getListData();
								this.dialogVisible = false;
								this.payType = {
									keyId: "",
									payTypeId: 1,
									payMoney: 0,
									payComment: ""
								};
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.$message.error("充值记录补款失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消充值记录补款"
					});
				})
				.finally(() => {
					this.isSubmitting = false;
				});
		},
		//获取状态信息
		getPayTypeList() {
			const paramer = {
				code: "PayType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeList = [];
						res.data.forEach((item) => {
							this.payTypeList.push({
								payTypeId: parseInt(item.code),
								payTypeName: item.name
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		tableRowClassName({ row }) {
			if (row.totalPayMoney < row.totalMoney) {
				return "row-red";
			}
			return "";
		},
		// 点击详情按钮
		handleDetail(row) {
			this.$refs.detailDialog.getDetailDialog(row);
		},
		// 点击创建销售订单提成按钮
		handleCreateCommission(row) {
			this.$refs.createCommission.getCreateCommissionDialog(row);
		},
		// 导出销售订单
		exportSalesOrder() {
			// 确认导出
			this.$confirm("确认导出选中门店的销售订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
			exportWithLoading(this, "exportLoading", () => ExportSalesOrder(this.formInline), "导出销售订单失败，请稍后再试！");
			});
		},
		// 日期选择器改变事件
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 点击退单按钮
		handleCancel(row) {
			this.$confirm("确认退单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				CancelSalesOrder({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "退单成功！"
							});
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("退单失败，请稍后再试！");
					});
			});
		},
		// 获取客户信息列表
		GetCustomerList(storeKeyId) {
			const paramer = {
				keyId: storeKeyId
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					this.customerList = [];
					if (res.code == 1) {
						this.customerList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取客户信息失败!");
				});
		},
		// 门店选择器事件
		handleStoreChange(val) {
			if (val.length > 0) {
				this.formInline.storeKeyId = val;
				this.GetCustomerList(val);
			} else {
				this.formInline.storeKeyId = "";
				this.customerList = [];
			}
		}
	}
};
</script>

<style scoped>
.table-minheight {
	margin-top: 0;
}

.row-red {
	background-color: #fff1f0 !important;
}

.row-red td {
	color: #f56c6c !important;
}

.arrears-dialog {
	.el-dialog__body {
		padding-top: 15px;
		padding-bottom: 10px;
		max-height: none;
		overflow-y: visible;
	}
}

.arrears-dialog-content {
	width: 100%;
}

.pay-types-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-types-row {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
}

.pay-type-item {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: #fafafa;
	border-radius: 6px;
	border: 1px solid #ebeef5;
	transition: all 0.3s ease;
	gap: 15px;
	width: calc(50% - 7.5px);
	box-sizing: border-box;

	&:hover {
		border-color: #409eff;
		background: #f0f9ff;
	}

	&-active {
		border-color: #409eff;
		background: #f0f9ff;
		box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.15);
	}
}

.pay-type-label {
	width: 100px;
	font-weight: 600;
	color: #303133;
	font-size: 14px;
	flex-shrink: 0;
	white-space: nowrap;
}

.arrears-form :deep(.el-form-item__label) {
	white-space: nowrap;
}

.arrears-form :deep(.el-table td),
.arrears-form :deep(.el-table th) {
	white-space: nowrap;
}

.pay-types-row .el-input-number {
	width: 140px;
	flex-shrink: 0;
}

.pay-types-row .el-input {
	flex: 1;
	min-width: 100px;
}
</style>
